<template>
    <div class="item col-6 col-sm-6 col-md-6 col-lg-3 my-4">
        <a class="item-link no-underline" :href="'/' + coloredProduct.slug">
            <custom-product-thumbnails
                class="thumbnail w-100"
                :coloredProduct="coloredProduct"
                :thumbnails="coloredProduct.images"
            />
            <custom-product-title class="title mt-2 mt-lg-0" :title="coloredProduct.title" :score="coloredProduct.score" />
        </a>
    </div>
</template>

<script>
import CustomProductThumbnails from '../../custom-colored-product/card/custom-product-thumbnails.vue';
import CustomProductTitle from '../../custom-colored-product/card/custom-product-title.vue';
export default {
    components: {
        CustomProductThumbnails,
        CustomProductTitle,
    },
    props: {
        coloredProduct: {
            type: Object,
            required: true,
        },
        gant: {
            type: Boolean,
        },
        vermont: {
            type: Boolean,
        },
    },
    data() {
        return {};
    },
    methods: {},
    computed: {},
};
</script>

<style lang="scss" scoped>
.item {
    margin: 0;
}
.thumbnail {
    margin-bottom: 15px;
}
.title {
    font-size: 12px !important;
}
</style>
